module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-05.ae98becc.png";